var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM12.8538 5.85371C13.0487 5.65809 13.0487 5.34186 12.8538 5.14624C12.6581 4.95125 12.3419 4.95125 12.1462 5.14624L6.49938 10.7928L3.85313 8.14609C3.65812 7.9511 3.34125 7.9511 3.14625 8.14609C2.95125 8.34171 2.95125 8.65794 3.14625 8.85355L6.14625 11.8534C6.34188 12.0484 6.65812 12.0484 6.85375 11.8534L12.8538 5.85371Z",
    fill: "#1EBB8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.ce0a8258744327035e7e309caeee5e57.svg";
export { ForwardRef as ReactComponent };